module.exports = __webpack_public_path__ + "img/6.7316ec8d.png";